var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33301 5.41844C1.33301 7.71962 3.19849 9.5851 5.49967 9.5851C7.80086 9.5851 9.66634 7.71962 9.66634 5.41844C9.66634 3.11725 7.80086 1.25177 5.49967 1.25177C3.19849 1.25177 1.33301 3.11725 1.33301 5.41844ZM5.93587 4.98224V5.41844V7.91844V8.35463L5.06348 8.35463V7.91844V5.41844V4.98224H5.93587ZM5.06348 3.3351V3.7713H5.93587V3.3351V2.91844V2.48224L5.06348 2.48224L5.06348 2.91844V3.3351Z",
    fill: "#848AA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGrey);
export default __webpack_public_path__ + "static/media/infoGrey.60e3a158235a7acb58acff3cc4042ddc.svg";
export { ForwardRef as ReactComponent };